export const environment = {
  production: true,
  esriApiURL: 'https://js.arcgis.com/4.34/',
  restApiURL: 'https://rotaplan.paineltarget.com.br:55002/',
  restApiTransp: 'https://rotaplan.paineltarget.com.br:25002/',
  url_SvgService: 'https://rotaplan.paineltarget.com.br:55002',
  url_telaOcorrencias: 'https://rotaplan.paineltarget.com.br/RotaPlanV2/OcorrenciaNovo',
  path_Ocorrencia: '/RotaPlanV2/OcorrenciaNovo/index.html',
  urlBaseJasper: 'https://rotaplan.paineltarget.com.br:15002/jasperserver/flow.html?_flowId=viewReportFlow&reportUnit=',
  usuarioJasper: 'amFzcGVyYWRtaW4=',
  passwordjasper: 'bW9pdGd0MjUyNg==',
  usuarioLogado: "",
  baseDados: "",
  servidor: ""
};
